<template>
    <v-app>
        <v-container fluid>
            <v-row>
                <v-col>
                    <v-expansion-panels v-model="panel">
                        <v-expansion-panel>
                            <v-expansion-panel-title
                                color="blue-grey-lighten-4"
                                class="panel-header"
                            >
                                Letter Info
                            </v-expansion-panel-title>
                            
                            <v-expansion-panel-text>
                                <v-form ref="addLetter" id="addLetter">
                                    <v-row class="pt-2">
                                        
                                        <v-col cols="12" class="px-8">
                                            <v-label class="text-subtitle-1 font-weight-bold mb-1"
                                            >Subject</v-label
                                            >
                                            <v-text-field
                                            label="Subject"
                                            class="visually-hidden-label"
                                            density="compact"
                                            single-line
                                            variant="outlined"
                                            bg-color="grey-lighten-4"
                                            v-model="subject.value.value"
                                            :error-messages="subject.errorMessage.value"
                                            autocomplete="off"
                                            clearable
                                            ></v-text-field>
                                        </v-col>

                                        <v-col cols="12" class="px-8">
                                            <v-label class="text-subtitle-1 font-weight-bold mb-1"
                                            >Letter Body</v-label
                                            >
                                            <Ckeditor
                                            :editor="ClassicEditor"
                                            v-model="body.value.value"
                                            :config="editorConfig"
                                            />
                                        </v-col>

                                        <v-col cols="12" class="px-8">
                                            <v-label class="text-subtitle-1 font-weight-bold mb-1">Letter Terms & Conditions</v-label
                                            >
                                            <Ckeditor
                                            :editor="ClassicEditor"
                                            v-model="terms.value.value"
                                            :config="editorConfig"
                                            />
                                        </v-col>

                                        <v-col cols="12" class="px-8">
                                            <v-label class="text-subtitle-1 font-weight-bold mb-1"
                                            >Letter Regards</v-label
                                            >
                                            <Ckeditor
                                            :editor="ClassicEditor"
                                            v-model="regards.value.value"
                                            :config="editorConfig"
                                            />
                                        </v-col>

                                        <v-col>
                                            <v-layout class="justify-end px-8 pb-4">
                                                <v-btn
                                                    class="bg-primary"
                                                    variant="flat"
                                                    @click="submitForm"
                                                    :loading="loading"
                                                >
                                                    UPDATE
                                                </v-btn>
                                            </v-layout>
                                        </v-col>
                                        
                                    </v-row>
                                </v-form>
                            </v-expansion-panel-text>
                        </v-expansion-panel>
                    </v-expansion-panels>
                </v-col>
            </v-row>
        </v-container>
    </v-app>
</template>

<script>
import { Ckeditor } from "@ckeditor/ckeditor5-vue";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import { useField, useForm } from "vee-validate";
import * as yup from "yup";
import { useStore } from "vuex";
import { ref } from "vue";
import { toast } from "vue3-toastify";
import { useRouter } from "vue-router";

export default {
    components: {
        Ckeditor,
    },
    data: () => ({
        panel: [0],
        loading: false,
        dataLoaded: false,
    }),
    created() {
        if (!this.$store.getters.getSlsLetterInfo?.data?.length) {
            this.$store.dispatch("getSlsLetterInfo");
        }
    },
    computed: {
        getSlsLetterInfo() {
            return this.$store.getters.getSlsLetterInfo?.data?.[0] || {};
        },
    },
    watch: {
        getSlsLetterInfo: {
            handler(newVal) {
                if (newVal?.subject && !this.dataLoaded) {
                    this.setFormData(newVal);
                    this.dataLoaded = true;
                }
            },
            immediate: true,
            deep: true,
        },
    },
    methods: {
        setFormData(data) {
            this.subject.value.value = data.subject || "";
            this.body.value.value = data.subject || "";
            this.terms.value.value = data.terms || "";
            this.regards.value.value = data.regards || "";
            this.letter_id = data.id || "1";
        },
        submitForm() {
            this.loading = true;
            this.submit().finally(() => {
                this.loading = false;
            });
        },
    },
    setup() {
        const store = useStore();
        const router = useRouter();

        const { handleSubmit, resetForm } = useForm({
            validationSchema: yup.object({
                subject: yup.string().required().label("Subject"),
                terms: yup.string().required().label("Letter terms"),
                body: yup.string().required().label("Letter body"),
                regards: yup.string().required().label("Regards"),
            }),
        });

        const subject = useField("subject");
        const body = useField("body");
        const terms = useField("terms");
        const regards = useField("regards");
        const letter_id = ref("1");

        const submit = handleSubmit((values) => {
        const payload = {
            ...values,
            id: letter_id.value,
        };
        store
            .dispatch("saveUpdateSlsLetterInfo", payload)
            .then((response) => {
                resetForm();
                toast.success(response.data.message, { timeout: 3000 });
                // setTimeout(() => router.push({ name: "add-rfq" }), 2000);
            })
            .catch((error) => {
                const message = error.response?.data?.message || "Failed to update letter";
                toast.error(message);
                console.error("Submission error:", error);
            });
        });

        return {
            subject,
            body,
            terms,
            regards,
            submit,
            letter_id,
            ClassicEditor,
            editorConfig: {
                toolbar: {
                items: [ "heading", "|", "bold", "italic", "underline", "|", "link", "bulletedList", "numberedList", "|", "outdent", "indent", "|", "blockQuote", "|", "undo", "redo",],},
                language: "en",
            },
        };
    },
};
</script>

<style>
.visually-hidden-label .v-field-label {
    display: none !important;
}

.panel-header {
    font-weight: bold;
    font-size: 1.1rem;
}
</style>
v
